// Explore-stats page: Presidents of the Senate.
// Recreates the Handbook page — every President since Federation, party
// at appointment & cumulative length of service, longest tenures, and a
// sortable name/party/period/duration table with PHID-linked names
// (#201). Thin wrapper around the shared OfficeHolderTenure scaffold
// — mirror of Speakers (#200), same data shape from `_officeholder_stats`.

import React from 'react';
import OfficeHolderTenure from './OfficeHolderTenure';

export default function Presidents() {
  return (
    <OfficeHolderTenure
      slug="presidents"
      title="Presidents of the Senate"
      description={
        'Presidents of the Senate since Federation '
        + '— ranked by cumulative tenure'
      }
    />
  );
}
